import React, { useState } from "react";
import { useUserAdminExtend } from "../../../hooks/useAdminUser";
import UserListView, { UserItem } from "./UserListView/UserListView";
import Pagination from "../../../../../common/components/organisme/Pagination/Pagination";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import TextInputSearch from "../../../../../common/components/atom/TextInputSearch/TextInputSearch";
import { JWayIcon } from "../../../../../common/assets/JWayIcons";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { UserFilterPresenter } from "../UserFilter/UserFilter";
import { UserExtendInfo } from "../../SingleUser/UserInfo/UserInfo";


export default function UserListPresenter({pageSize = 10, orderBy ="user_firstname", orgnizationId, withFilter}: {pageSize?: number, orderBy?: string, orgnizationId?: string, withFilter?: boolean}) {
  const { userAdminExtendListQuery:getAllAdminUserQuery } = useUserAdminExtend({
    pageSize: pageSize,
    orderBy: orderBy,
    preFilter:  orgnizationId ? {organization_id: `=${orgnizationId}`} : undefined,
  });

  const [isSearchLoading, setSearchLoading] = useState(false);
  const navigationApp = useNavigationApp();

  const content: UserItem[] =
    getAllAdminUserQuery?.data?.data?.map((user) => {
      return {
        id: user.user_orga_id,
        firstName: user.user_firstname,
        lastName: user.user_lastname,
        email: user.user_email,
   
        onClick: () => navigationApp.goToSingleUserExtend(user.user_orga_id),
        organizationNameRender: () => (
         <UserExtendInfo userOrgaId={user.user_orga_id} info="organization_id" emptyText="No organization"/>
        ),
        

       userStatusRender: () => <UserExtendInfo userOrgaId={user.user_orga_id} info="user_orga_status" styled emptyText="No status"/>,
      userRole: user.user_orga_role
      };
    }) || [];

  const pagination = getAllAdminUserQuery.data?.pagination;
  return (
    <div>
      <TextInputSearch iconLeft={<JWayIcon type={"search"} size={20} color='#979797'/>} placeholder="Chercher un utilisateur" setIsLoading={setSearchLoading}  sendQuery={(query) => getAllAdminUserQuery.setSearch(query)} valueInit={getAllAdminUserQuery.sreachValue}/>
      {withFilter && <><div style={{marginBottom: 20}}/>
      <UserFilterPresenter />
      </>}
      {(!(isSearchLoading ||getAllAdminUserQuery.isLoading )) ?
      <>
      <div style={{marginTop: 20}}/>
     

      <UserListView content={content} nbFound={pagination?.total_count}/>
      <Pagination
        centered
        currentPage={pagination?.current_page}
        setCurrentPage={getAllAdminUserQuery.setPage}
        nbBtnToDisplay={5}
        lastPage={pagination?.total_pages}

      />      </> :     <LoaderSreen heigth="120px" />

}
      {getAllAdminUserQuery.isError &&(
        <ErrorScreenApp  axiosError={getAllAdminUserQuery.error}/>
      )}
    </div>
  );
}

